import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material';

@Component({
	selector: 'upm-confirm-save-dialog',
	templateUrl: './confirm-save-dialog.component.html',
	styleUrls: ['./confirm-save-dialog.component.less']
})
export class ConfirmSaveDialogComponent {

	name: string = '';

	constructor(@Inject(MAT_DIALOG_DATA) public data: { name: string }) {
		this.name = data.name;
	}

}
